@if (error(); as err) {
    <div class="vz-error vz-error-info" [class.vz-error-border]="border()">
        <div class="vz-error-title">{{ err.title }}</div>
        @if (err.text) {
            <div class="vz-error-text" [style.margin-bottom.px]="err.debug ? undefined : 0">{{ err.text }}</div>
        }
        @if (err.debug) {
            <div class="vz-error-url">
                @if (err.method) {
                    <b>{{ err.method }}</b>
                }
                {{ err.url }}
            </div>
        }
        @if (showMore()) {
            @if (err.body) {
                <small>REQUEST</small>
                <pre class="vz-error-details" animate.enter="vza-show-h" animate.leave="vza-hide-h">{{ err.body | jsonSafe:4 }}</pre>
            }
            <small>{{ err.error ? '' : 'EMPTY ' }}RESPONSE</small>
            @if (err.error) {
                <pre class="vz-error-details scroll-y" syle="max-height: 500px" animate.enter="vza-show-h" animate.leave="vza-hide-h">{{ err.error | jsonSafe:4 | ellipsis:4096 }}</pre>
            }
            @else {
                <pre class="vz-error-details txt-error" animate.enter="vza-show-h" animate.leave="vza-hide-h">&nbsp;</pre>
            }
        }
        @else {
            <div class="vz-error-guid" animate.enter="vza-show-h" animate.leave="vza-hide-h">{{ err.guid }}</div>
        }
        @if (err.debug) {
            <div class="vz-error-links layout center">
                <span class="mr1 fs-l vz-btn-xs"
                    title="Скопировать ошибку"
                    (click)="$event.stopImmediatePropagation(); copyError();"
                    [class]="copied() ? 'vzi-check txt-ok disabled' : 'vzi-copy txt-pl'">
                </span>
                <span class="flex"></span>
                <a (click)="$event.stopImmediatePropagation(); showMore.set(!showMore())">{{ showMore() ? 'скрыть' : 'показать' }} подробности</a>
            </div>
        }
    </div>
    @if (showClearButton()) {
        <button class="vz-error-clear-button" nz-button nzSize="small" (click)="error.set(undefined)">Скрыть сообщение об ошибке</button>
    }
}
